import { render, staticRenderFns } from "./login.vue?vue&type=template&id=860d4112&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"
import style0 from "./login.vue?vue&type=style&index=0&id=860d4112&prod&lang=scss&scoped=true"
import style1 from "./login.vue?vue&type=style&index=1&id=860d4112&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860d4112",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OtpInput: require('/usr/src/app/components/OtpInput.vue').default})
